export * from './ShoppingBagStrapDetails';
